import { Routes } from '@angular/router';
import { OktaCallbackComponent, OktaAuthGuard } from '@okta/okta-angular';

import { ConfigHomeComponent } from './config-home/config-home.component';
import { ViewFilesComponent } from './view-files/view-files.component';

export const routes: Routes = [
  { path: 'oauth2/idpresponse', component: OktaCallbackComponent },
  { path: '', redirectTo: '/home', pathMatch: 'full' },
  { path: 'home', component: ConfigHomeComponent, canActivate: [OktaAuthGuard] },
  { path: 'view', component: ViewFilesComponent, canActivate: [OktaAuthGuard] },
  { path: 'accounts', component: ViewFilesComponent, canActivate: [OktaAuthGuard] },
  { path: 'manual', component: ConfigHomeComponent, canActivate: [OktaAuthGuard] },


  { path: 'viewfile/:key/:filename', component: ViewFilesComponent,canActivate: [OktaAuthGuard] },
];